const userDownloadCCPlatform = 'verizon_cat_v2024';

export { userDownloadCCPlatform };
